const state = {
  tenantInfo: {}
};

const mutations = {
  INIT_TENANT_INFO: (state, data) => {
    state.tenantInfo = data;
  },
};

export default {
  namespaced: true,
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/tenant.js